import baseHttpService from "core/http/singleton/base";

import { CategoryItem } from "./resTypes";

import {
  getCategoryPersonalInformationUrl,
  getCategoryInternalDocumentUrl,
  getCategoryRecruitmentUrl,
} from "./urls";
import { SCREEN } from "helper/roleChecker/Screens";
import { CATEGORY_FACTORY } from "redux-store/static/redux/category";

export const getCategoryPersonalInformationApi = async (
  type: string
): Promise<CategoryItem[]> => {
  const res = await baseHttpService.get<CategoryItem[]>(
    getCategoryPersonalInformationUrl(type)
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getCategoryInternalDocumentApi = async (
  type: string
): Promise<CategoryItem[]> => {
  const res = await baseHttpService.get<CategoryItem[]>(
    getCategoryInternalDocumentUrl(type, SCREEN.IP_001)
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getCategoryFactoryApi = async (
  key: string,
  query?: Record<string, any>,
  params?: Record<string, any>
): Promise<CategoryItem[]> => {
  const { url } = CATEGORY_FACTORY[key](query);

  const res = await baseHttpService.get<CategoryItem[]>(url, params);

  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getCategoryRecruitmentApi = async (
  type: string
): Promise<CategoryItem[]> => {
  const res = await baseHttpService.get<CategoryItem[]>(
    getCategoryRecruitmentUrl(type)
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};
